const loadersEnum = {
  AUDIO_LOAD_PROGRESS: 0,
  IMAGE_LOAD_PROGRESS: 1,
};

Object.freeze(loadersEnum);

export default loadersEnum;
